import { thmSslBaseUrl, thmOrgId } from 'server-data/flconfigs';
import { oneLineTrim } from 'common-tags';

export let tagsSessionId = localStorage.getItem('tags_session_id');

// Helper function to generate a session id
function getSessionId() {
  let sessionId = '';

  // 80 character long session id
  for (let i = 0; i < 20; i++) {
    sessionId += random4CharString();
  }

  return sessionId;
}

// Wrapped setItem() in a function due to empty block statement lint error
function setSessionIdToLocalStorage(tagsSessionId) {
  try {
    localStorage.setItem('tags_session_id', tagsSessionId);
  } catch (err) { // Safari private browsing mode fix
    return false;
  }
}

// Helper function to generate a string of 4 random characters
function random4CharString() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

// For flndev environments, disable Threatmetrix if the SSL base URL is false.
if (thmSslBaseUrl) {
  // Generate new sessionId if none is present in localStorage
  if (tagsSessionId === null) {
    tagsSessionId = getSessionId();
    setSessionIdToLocalStorage(tagsSessionId);
  }

  const arr = document.getElementsByName('thm_session');
  for (let i = 0; i < arr.length; i++) {
    arr[i].setAttribute('value', tagsSessionId);
  }

  // Inject script tag in document
  const url = oneLineTrim`
    ${thmSslBaseUrl}/fp/tags.js?org_id=${thmOrgId}
    &session_id=${tagsSessionId}`;
  const po = document.createElement('script');
  po.type = 'text/javascript';
  po.async = true;
  po.src = url;
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(po, s);

  // Set thm_session in cookie
  const date = new Date();
  // 1 year expiration time for cookie
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
  const expires = `path=/;expires=${date.toUTCString()}`;
  document.cookie = `session2=${tagsSessionId}; ${expires}`;
}
